import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureReferralFromSearch } from '@/utils/referral';

// Global capture of referral parameters.
// Ensures a prospect keeps the referrer code in memory even if they browse
// the site before signing up (any page can carry ?ref= / ?amb= etc.).
export default function ReferralCapture() {
  const location = useLocation();

  useEffect(() => {
    try {
      captureReferralFromSearch(location?.search || '');
    } catch {
      // ignore
    }
  }, [location?.search]);

  return null;
}
